export default __webpack_public_path__ + "static/media/EmailIcon.83792d31.svg";